import { render, staticRenderFns } from "./MagicWand.vue?vue&type=template&id=8b03cb6c&"
import script from "./MagicWand.vue?vue&type=script&lang=js&"
export * from "./MagicWand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports